import React from "react";
import {useTranslation} from "react-i18next";
import ListLoader from "../../utils/loader/ListLoader";
import styles from "./LoginForm.module.scss";
import KnownCustomer from "../../checkout/steps/Login/KnownCustomer/KnownCustomer";

const LoginForm: React.FC<{onLoggedIn?: () => void}> = ({onLoggedIn}) => {
  const {t} = useTranslation();

  return (
    <React.Suspense fallback={<ListLoader />}>
      <KnownCustomer onLoggedIn={onLoggedIn} />
      <div className={styles.linksWrapper}>
        <p className={styles.linksHeader}>{t("Noch kein Kunde?")}</p>
        <a
          className={styles.linksButton + " " + "button button-white"}
          href={t("/kundenkonto/kundenregistrierung.html")}
        >
          {t("Jetzt registrieren")}
        </a>
      </div>
    </React.Suspense>
  );
};

export default LoginForm;
